import React, {Component} from 'react';
import "./App.css";


class Geschehen extends Component {


	UNSAFE_componentWillMount(){
		window.scrollTo(0,0);
	}

render() {	
  return (	

	<div className="homeApp">

	<div className="contentHome" >	

	<div className="Frei">
	<h2>Bürgerrechte sind eingeschränkt,<br/>zurecht?</h2>
	  
		
		<div className="Ein">	
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=R_5eEtHM4qA" target="_blank" >
			"Die Regierung hat die Justiz gekidnappt" 03.12.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=EKPeA4ck3jo" target="_blank" >
			Wenn das Grundgesetz komplett suspendiert wird - TE Wecker am 02.07.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=mhzoO4NLSSQ" target="_blank" >
			Skandal: Dieser Richter ließ Lina Engel laufen! 04.06.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=_HaZKy-3lz0&t=63s" target="_blank" >
			Willkommen im Unrechtsstaat / Nacktes Niveau 22.04.2023
			</a>
			<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/bundestags-gutachten-bezweifelt-neutralitaet-von-karlsruhe/" target="_blank" >
			Bundestags-Gutachten bezweifelt Neutralität von Karlsruhe 14.11.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=HZmE8DvdV3A" target="_blank" >
			Sensations-Urteil: „Quarantäne war rechtswidrig“ entscheidet Bayerischer Verwaltungsgerichtshof 25.08.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=vHYAKGM2ayo" target="_blank" >
				Sind Ärzte tatsächlich von der persönlichen Haftung für #Impfschäden befreit? 11.04.2022
			</a>	
			<a className="videoText"  rel="noopener" href="https://t.me/Haintz/19028" target="_blank" >
			‼️ DIE UNTAUGLICHKEIT des PCR-TESTS zum Nachweis einer Infektion mit dem SARS-CoV-2-Virus ‼️ 03.01.2022
			</a>
			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=-Ifl4xCg2l8" target="_blank" >
			Einschränkung von Grundrechten. Artikel 22 im Gesetz vom 10.12.21 erklärt.
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=ZKcDLSRUxfI" target="_blank" >
				Der Staat begeht Machtmissbrauch | Ralf Ludwig
			</a>
			<a className="videoText" rel="noopener"  href="https://reitschuster.de/post/long-covid-bei-justitia/" target="_blank" >
				Long Covid bei Justitia? 22.06.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Z7X1KE-ZUqA" target="_blank" >
				RICHTER GIBT BUNDESVERDIENSTKREUZ ZURÜCK!!! 06.05.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=__LKzDbb444" target="_blank" >
				„Sensationsurteil“ aus Weimar 04.05.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=IR6v2t0DeaM" target="_blank" >
				Sitzung 49: Der Offenbarungseid 23.04.2021
			</a>	
			<a className="videoText" rel="noopener"  href="https://odysee.com/@CrumanFilms:2/Bahner_Merkel:c" target="_blank" >
				Änderung des Infektionsschutzgesetzes von Beate Bahner
			</a>					
			<a className="videoText" rel="noopener"  href="https://odysee.com/stoppt-die-änderung-des:3?" target="_blank" >
				Erklärung des Infektionsschutzgesetzes von Markus Haintz
			</a>		
			<a className="videoText" rel="noopener"  href="https://odysee.com/@MenschenMachenMut:c/Update-Reiner-Fuellmich:d" target="_blank" >
				Update von RA Füllmich 13.04.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://odysee.com/@pankalla:6/prof.-schwab,-rain-ringeisen-zu:1" target="_blank" >
				Prof. Schwab, RA Pickartz zu Schnelltests & Maskenpflicht und dem Oster Lockdown 22.03.2021
			</a>			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=-opKoSh7lsk"  target="_blank">
				Untersuchungsausschuss Corona-Ausschuss<br/>
				Schlussstrich 2020  01.01.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=XxH7jlbTsxA" target="_blank" >
				Arbeitnehmer wehrt sich gegen Freistellung 09.04.2021
			</a>		

			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=L8synzDTCw8" target="_blank" >
					<strong>Amnesty International</strong> kritisiert <br/>07.04.2021
			</a>						
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=b5NsnjyWhqo"  target="_blank">
				RA Fuellmich Sammelklage 01.10.2020
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=RPCugtHFWzA"  target="_blank">
				Neues IfSG - Anwälte schlagen Alarm	16.11.2020
			</a>	
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=9FD2lO8tjmw&t=244s"  target="_blank">
				RA Ralf Ludwig Rede  19.11.2020
			</a>	
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=-hFdRSagaEs"  target="_blank">
			Gericht bestätigt Versagen der Politik<br/>Reiner Fuellmich Amtsgericht Weimar  21.01.2021
			</a>									
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=G6Uj6uz5zyM"  target="_blank">
				RA Ralf Ludwig  28.10.2020
			</a>	
						
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=1vf4wsYkhJ0" target="_blank" >
				Doc Ulli tv Rechtsanwälte	25.08.2020
			</a>

			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=x46OM6qPlcA&t=90s" target="_blank" >
				RA Pankalla	22.09.2020
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=ygDoiJICtj0"  target="_blank">
						Amtseid der Kanzlerin
			</a>
		</div>
	</div>
</div>



</div>

  );
};
};

export default Geschehen;
